// extracted by mini-css-extract-plugin
export default {"drawer-template-additional-details-skeleton":"styles_drawer-template-additional-details-skeleton__2FP-X","shimmer":"styles_shimmer__I4vDZ"};